import React, { useRef } from 'react';
import { Article } from './styles';
import useLazyLoadImages from '@/components/features/lazyImage/useLazyLoadImages';
import useWrapTables from '@/core/hooks/useWrapTables';

interface StyledArticleProps {
	dangerouslySetInnerHTML?: { __html: string };
	children?: React.ReactNode;
}

const StyledArticle: React.FC<StyledArticleProps> = ({ dangerouslySetInnerHTML, children }) => {
	const articleRef = useRef<HTMLDivElement>(null);

	useLazyLoadImages(articleRef);
	useWrapTables(articleRef);

	return (
		<Article ref={articleRef} dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
			{children}
		</Article>
	);
};

export default StyledArticle;